<template>
  <v-container class="fin-tracking-info mx-0 px-0">
    <v-row class="fin-logo-row text-center justify-start align-center">
      <v-col>
        <fin-logo-full dark
                       size="14em"
                       class="mb-4"/>
        <h1>Tracking Info</h1>
      </v-col>
    </v-row>

    <div class="fin-tracking-info-content">
      <v-row class="my-12">
        <v-col class="mx-6">
          <v-row class="mx-0 px-0">

            <v-col class="mx-0 px-0 ">
              <v-btn outlined
                     dark
                     icon
                     large
                     style="pointer-events: none;">
                <!--              <v-icon>mdi-atom</v-icon>-->
                <v-icon>mdi-head-lightbulb-outline</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10" class="mx-0 px-0">
              Weiterentwicklung des Dienstes zur Verbesserung der Benutzerfreundlichkeit.
            </v-col>
          </v-row>


        </v-col>
      </v-row>
      <v-row class="footer mx-auto">
        <v-col>
          <v-btn class="mb-4"
                 width="100%"
                 @click="requestPermission">Fortsetzen
          </v-btn>
          <p>
            Du kannst diese Einstellung auch später in den Einstellungen deines Gerätes ändern.
          </p>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import FinLogoFull from "@/components/common/logo/LogoFull"
import {AppTrackingTransparency} from "capacitor-plugin-app-tracking-transparency"

export default {
  name: "TrackingInfo",
  components: {
    FinLogoFull
  },
  methods: {
    async requestPermission() {

      const response = await AppTrackingTransparency.requestPermission()
      console.log("requestPermission", response)
      // { status: 'authorized' } for example
      await this.$router.push("/")
    },
  }
}
</script>

<style lang="scss" scoped>
.fin-tracking-info {
  height: 100%;
  width: 100%;
  max-width: 100%;
  font-size: 1.1em;
  background-color: $fin-color-accent-blue;
  color: $fin-color-primary-light;

  .fin-tracking-info-content {
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }

  .fin-logo-row {
    background-color: $fin-color-primary-light;
    color: $fin-color-primary-dark;
  }

  .footer {
    position: absolute;
    bottom: 20px;
  }
}
</style>
